import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
    props: {
        heading: {
            type: [String, Object],
            default: ''
        },
        title: {
            type: [String, Object],
            default: ''
        }
    },
    setup() {
        const opened = ref(false);
        return {
            opened
        };
    }
});
